import type {ReactElement} from 'react';
import React from 'react';
import {BaseGlowOption} from '@Components/poster-editor/components/poster-editing-side-panel/components/base-glow-option';
import type {AuraType} from '@PosterWhiteboard/classes/item-aura.class';
import {useSingleActivePosterItemId} from '@Hooks/poster-editor/useSingleActivePosterItemId';
import {useGetKeyFromAuraOfActiveItem} from '@Hooks/poster-editor/useGetKeyFromAuraOfActiveItem';

interface ItemGlowOptionProps {
  onClickColorFill(): void;
}

export function ItemGlowOption({...props}: ItemGlowOptionProps): ReactElement | null {
  const activeItemId = useSingleActivePosterItemId() ?? '';
  const activeItem = activeItemId ? window.posterEditor?.whiteboard?.getItemForId(activeItemId) : undefined;
  const activeItemAuraType = useGetKeyFromAuraOfActiveItem('type');
  const activeItemGlowColor = useGetKeyFromAuraOfActiveItem('glowColor');

  if (!activeItem) {
    throw new Error('Active item does not exist in item glow options');
  }

  if (!('aura' in activeItem) || !activeItemGlowColor || activeItemAuraType === undefined) {
    throw new Error('Active item does not have aura and glow properties');
  }

  const onClickHandler = (glowType: AuraType): void => {
    void activeItem.updateFromObject({
      aura: {
        type: Number(glowType),
      },
    });
  };

  return (
    <BaseGlowOption
      auraType={activeItemAuraType}
      glowColor={activeItemGlowColor}
      onApplyGlow={onClickHandler}
      onClickColorFill={(): void => {
        props.onClickColorFill();
      }}
    />
  );
}
